import React from 'react'
import { Textarea, Checkbox } from '@baseV2'
import { ConsentRow } from './styles'
import { plainChangeHandler } from './inputAdapters'

const MessageConsentSection = ({ message, tcRequired, onChange, onCheckBoxChange, showMessage = true }) => (
	<>
		{showMessage && (
			<Textarea
				id='enquiry-item-message'
				label={message?.label}
				disabled={message?.disabled}
				value={message?.value}
				onChange={plainChangeHandler(onChange('message'))}
			/>
		)}
		<ConsentRow>
			<Checkbox
				id='Checkbox'
				size={1}
				disabled={tcRequired?.disabled}
				checked={tcRequired?.value}
				value={tcRequired?.value}
				onChange={onCheckBoxChange}
				label={tcRequired?.label}
			/>
		</ConsentRow>
	</>
)

export default MessageConsentSection
